import { getDiscountTotalWithoutShippingCoupon } from '@cart-services/core/cartService'
import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useFpB2bCouponService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-coupon-service'
import { ButtonFooterAmount } from '@cart-ui/ButtonFooterAmount/ButtonFooterAmount'
import { useFastpassMerchantGoogleAnalyticEvent } from '@dni-analysis'
import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Divider } from '@pets-ui/Divider/Divider'
import { Footer } from '@pets-ui/Footer/Footer'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CartFilled, GiftFilled } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { useProductCatalog } from '../../../../fp-b2b-shared/hooks/use-product-catalog'
import { DIALOG_ORDER_DETAIL, DialogOrderDetail, type DialogOrderDetailProps } from '../../../cart/components/DialogOrderDetail/DialogOrderDetail'
import { FooterCoupon } from '../../../cart/components/FooterCoupon/FooterCoupon'
import { FooterShippings } from '../../../cart/components/FooterShippings/FooterShippings'
import { DialogRegularGiveawayTips } from '../DialogRegularGiveawayTips/DialogRegularGiveawayTips'
import { FloatingButler } from '../FloatingButler/FloatingButler'

export const ProductCatalogFooter = () => {
  const { cartTotalQuantity, showButler, countryCode, projectCode, currency, campaignId, campaignCode, platform } = useProductCatalog()
  const { calculateResult: campaignCouponCalculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const { regularGiveaways } = useFpB2bCouponService(campaignId, projectCode, countryCode, campaignCode, platform)
  const { sendBeginCartEvent, sendClickGiftIconEvent, sendClickOrderTotalEvent } = useFastpassMerchantGoogleAnalyticEvent({ projectCode, countryCode, campaignId })
  const { total } = campaignCouponCalculateResult || {}
  const [isOpen, setIsOpen] = useState(false)
  const history = useHistory()
  const { openDialog: openDialogOrderDetail, closeDialog: closeDialogOrderDetail } = useDialog<DialogOrderDetailProps>(DIALOG_ORDER_DETAIL)
  const discountTotalWithoutShippingCoupon = getDiscountTotalWithoutShippingCoupon(campaignCouponCalculateResult?.discount_items || [])

  const handleCheckoutClick = async () => {
    history.push(`/merchant/${campaignCode}/cart`)
    sendBeginCartEvent()
  }

  const handleDialogGiftOpen = () => {
    setIsOpen(true)
    sendClickGiftIconEvent()
  }
  const handleDialogGiftClose = () => setIsOpen(false)

  const handleFooterAmountClick = () => {
    openDialogOrderDetail({
      handleCheckout: () => {
        handleCheckoutClick()
        closeDialogOrderDetail()
      },
      actionButtonText: '前往購物車',
    })
    sendClickOrderTotalEvent()
  }

  return (
    <>
      <FooterStack
        renderTransparentFooters={() => (
          <>
            <Footer variant="transparent" ContainerProps={{ justifyContent: 'flex-end' }}>
              {showButler && <FloatingButler campaignId={campaignId} basePath={`/merchant/${campaignCode}`} />}
            </Footer>
            <FooterShippings
              totalAmount={campaignCouponCalculateResult?.total_after_discount}
              currency={currency}
              shippingMethods={campaignCouponCalculateResult?.shipping_methods}
              pt={0}
            />
          </>
        )}
      >
        <FooterCoupon
          projectCode={projectCode}
          countryCode={countryCode}
          campaignId={campaignId}
          campaignCode={campaignCode}
        />
        <Divider />
        <Footer elevation={0}>
          <HStack justifyContent="space-between" width="100%">
            <HStack gap={2}>
              {regularGiveaways.length > 0
              && (
                <IconButton onClick={handleDialogGiftOpen}>
                  <VStack gap={0.5} alignItems="center">
                    <GiftFilled color={colors.grey800} />
                    <Text variant="caption" color={colors.grey800}>滿額禮</Text>
                  </VStack>
                </IconButton>
              )}
              <ButtonFooterAmount
                amount={total}
                shippingFee={campaignCouponCalculateResult?.shipping_total}
                currency={currency}
                onClick={handleFooterAmountClick}
                discountTotalWithoutShippingCoupon={discountTotalWithoutShippingCoupon}
              />
            </HStack>
            <HStack justifyContent="flex-end">
              <Button data-testid="button-product-catalog-go-next" startIcon={<CartFilled />} onClick={handleCheckoutClick} disabled={cartTotalQuantity === 0}>
                (
                {cartTotalQuantity.toLocaleString()}
                )
              </Button>
            </HStack>
          </HStack>
        </Footer>
      </FooterStack>
      <DialogRegularGiveawayTips open={isOpen} onClose={handleDialogGiftClose} />
      <DialogOrderDetail />
    </>
  )
}
